module.exports = __webpack_public_path__ + "img/hero.2c23b32b.png";